import { render, staticRenderFns } from "./allFeeList.vue?vue&type=template&id=c2314fa2&scoped=true"
import script from "./allFeeList.vue?vue&type=script&lang=js"
export * from "./allFeeList.vue?vue&type=script&lang=js"
import style0 from "./allFeeList.vue?vue&type=style&index=0&id=c2314fa2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2314fa2",
  null
  
)

export default component.exports